import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "react-circular-progressbar/dist/styles.css";

import Twotone2 from "../../assets/img/ic_twotone-euro2.svg";
import UserIcon from "../../assets/img/user-icon-gray.svg";

// ---------------------------------------------------------------------------
// Lightweight _t – drop-in for useTranslator
// ---------------------------------------------------------------------------
const _t = (key) => {
  const map = {
    setEffortRate: "Set Effort Rate",
    tenant: "Tenant",
    guarantor: "Guarantor",
    both: "Both",
    landlordsTypicallyPreferEffortRatesBelow:
      "Landlords typically prefer effort rates below 35%",
    affordable: "Affordable",
    stretching: "Stretching",
    risk: "Risk",
    averageMonthlyNetIncome: "Average Monthly Net Income",
    monthlyPayment: "Monthly Payment",
    effortRate: "Effort Rate",
    financialSkor: "Financial Skor",
    reconnectBank: "Reconnect Bank",
    scoreStatus: "Score Status",
    reliable: "Reliable",
    createdOn: "Created On",
    validTill: "Valid Till",
    accountHolder: "Account Holder",
    bankAccountUsedForScoring: "Bank account used for scoring",
  };
  return map[key] ?? key;
};

// ---------------------------------------------------------------------------
// Static display data
// ---------------------------------------------------------------------------
const scoreValue = 720;
const maxValue = 1000;
const efforRateLocal = 30;
const combinedIncome = 3200;
const effortAmount = 960;
const createdOnDate = "12-03-2025";
const validTillDate = "12-05-2025";
const accountHolder = "John Doe";
const ibanTail = "*4523";

// ---------------------------------------------------------------------------
// Pure helpers
// ---------------------------------------------------------------------------
const getProgressColor = (pct) => {
  if (pct < 20) return "#F3483E";
  if (pct < 40) return "#F77841";
  if (pct < 60) return "#F8E002";
  if (pct < 80) return "#99DE04";
  return "#05C200";
};

const getEffortColor = (val) => {
  if (val >= 1 && val <= 35) return "#99DE04";
  if (val > 35 && val <= 45) return "#F77841";
  if (val > 45) return "#F3483E";
  return "#7F7F7F";
};

const convertCurrencyFormat = (n) =>
  Number(n).toLocaleString("de-DE", { minimumFractionDigits: 0 });

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------
const DetailsSkorStatic = () => {
  const progressPct = (scoreValue / maxValue) * 100;
  const min = 10;
  const max = 50;

  const effortRateToggleOptions = ["tenant", "guarantor", "both"];

  return (
    <div className="row mainEffortRateWrapper">
      {/* ================================================================ */}
      {/* LEFT – Set Effort Rate                                            */}
      {/* ================================================================ */}
      <div className="col-md-6">
        <div className="Profile_summary2 skorsetbox p-3">
          <div className="d-flex justify-content-between flex-wrap w-100">
            <div className="d-flex justify-content-between w-100 flex-wrap">
              <h4 className="mb-0">{_t("setEffortRate")}</h4>

              {/* Toggle – tenant active, guarantor/both disabled (no completed guarantors) */}
              <div className="effortRateToggleContainer">
                {effortRateToggleOptions.map((option) => {
                  const isDisabled = ["guarantor", "both"].includes(option);
                  const isActive = option === "tenant";
                  return (
                    <div
                      style={{ display: "inline-block" }}
                      data-tooltip-id={
                        isDisabled ? "button-action-tooltip" : undefined
                      }
                      key={option}
                    >
                      <div
                        className={
                          `effortRateeBtn` +
                          (isActive ? " active" : "") +
                          (isDisabled ? " disabled pe-none" : "")
                        }
                      >
                        {_t(option)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Tenant sub-heading */}
            <p>{_t("landlordsTypicallyPreferEffortRatesBelow")}</p>
          </div>

          {/* Slider view */}
          <div>
            <div>
              <div
                className="skormeter vw-mt-4 w-100 position-relative"
                style={{ "--w": ((efforRateLocal - min) / (max - min)) * 100 }}
              >
                <Slider
                  min={min}
                  max={max}
                  value={efforRateLocal}
                  onChange={() => {}}
                  onChangeComplete={() => {}}
                  draggableTrack={true}
                />
                <div className="slider-labels">
                  <span>{_t("affordable")}</span>
                  <span></span>
                  <span>{_t("stretching")}</span>
                  <span></span>
                  <span>{_t("risk")}</span>
                </div>
              </div>
            </div>

            <div className="row effortRateIncomeWrapper vw-mt-4">
              {/* Average Monthly Net Income card */}
              <div className="col-md-6">
                <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center border-0">
                  <div className="d-flex justify-content-between align-items-end w-100">
                    <div
                      style={{ width: "100%" }}
                      className="d-flex justify-content-between align-items-center income_info_card"
                    >
                      <div className="Twotone_img d-flex align-items-center justify-content-center">
                        <img
                          src={Twotone2}
                          alt="Vector Icon"
                          className="TwotoneIcon"
                        />
                      </div>
                      <div style={{ width: "100%" }}>
                        <p className="Profileheading_change profile-mb d-flex align-items-center gap-2">
                          {/* llShowOnly=false → span is not underlined / not clickable */}
                          <span className="d-flex align-items-center custom-gap-1">
                            {_t("averageMonthlyNetIncome")}
                            <img
                              src="/images/arrow-right.svg"
                              alt="Vector Icon"
                              className="arrow-back-icon"
                            />
                          </span>
                          <div className="d-flex align-items-center gap-1">
                            <img
                              src={UserIcon}
                              alt="Vector Icon"
                              className="vactorImg vactorImg1"
                            />
                            {/* tenantCount=1, guarantorCount=0 → total 1 */}
                            <p className="length-text">1</p>
                          </div>
                        </p>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="Profileheading_change3">
                            €{convertCurrencyFormat(combinedIncome ?? 0)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Monthly Payment card */}
              <div className="col-md-6">
                <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center border-0">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div
                      style={{ width: "100%" }}
                      className="d-flex justify-content-between align-items-center income_info_card"
                    >
                      <div className="Twotone_img d-flex align-items-center justify-content-center">
                        <img
                          src="/images/max-rent-icon.svg"
                          alt="Vector Icon"
                          className="TwotoneIcon"
                        />
                      </div>
                      <div className="profile_heading_width">
                        <p className="Profileheading_change profile-mb d-flex align-items-center custom-gap-2">
                          {_t("monthlyPayment")}
                          {/* llShowOnly tooltip omitted – tenant never sees it */}
                        </p>
                        <div className="d-flex gap-2 align-items-center">
                          <p className="Profileheading_change3">
                            €
                            {convertCurrencyFormat(
                              Math.round(Number(effortAmount))
                            )}
                          </p>
                          <p
                            style={{
                              fontWeight: "700",
                              color: getEffortColor(efforRateLocal),
                            }}
                            className="Profileheading_change"
                          >
                            {`(${Math.round(efforRateLocal)}% ${_t("effortRate")})`}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* "Effort Rate Calculator" arrow – landlord only, omitted */}
            </div>
          </div>
        </div>
      </div>

      {/* ================================================================ */}
      {/* RIGHT – Financial Skor (scoreValue present, not expired, tenant)  */}
      {/* ================================================================ */}
      <div className="col-md-6">
        <div
          className="Profile_summary2 skorsetbox position-relative p-3 meterMainContainer"
          style={{ overflow: "hidden" }}
        >
          {/* isSkorExpired banner – omitted (score is valid) */}

          {/* Header – tenant branch: className="d-flex", text-start, reconnect button visible */}
          <div className="d-flex">
            <h4 className="text-start">{_t("financialSkor")}</h4>
            <button className="addGuarantorButton reconnectBank me-0 d-flex align-items-center justify-content-center hideOnMobile">
              {_t("reconnectBank")}
            </button>
          </div>

          <div className="row">
            {/* Circular progress meter */}
            <div className="col-5 col-md-6">
              <div style={{ position: "relative" }} className="skorSetWrapper">
                {/* Hidden SVG gradient */}
                <svg style={{ height: "0", position: "absolute", top: "0" }}>
                  <defs>
                    <linearGradient
                      id="progressGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop
                        offset="100%"
                        stopColor={getProgressColor(progressPct)}
                      />
                    </linearGradient>
                  </defs>
                </svg>

                {/* Tenant: no onClick (llShowOnly guard blocks it) */}
                <div className="skorr">
                  <CircularProgressbarWithChildren
                    value={progressPct}
                    maxValue={100}
                    circleRatio={0.78}
                    styles={buildStyles({
                      rotation: 0.61,
                      strokeLinecap: "round",
                      trailColor: "#e6f0e9",
                      textColor: "#1c1c1c",
                      pathTransitionDuration: 0.5,
                      pathColor: getProgressColor(progressPct),
                    })}
                  >
                    <div className="skills">
                      <div style={{ textAlign: "center", lineHeight: "1.8vw" }}>
                        <div
                          style={{
                            fontSize: "var(--text-24)",
                            fontWeight: "800",
                            color: "var(--ink)",
                          }}
                        >
                          {scoreValue}
                        </div>
                        <div
                          style={{
                            fontSize: "var(--text-12)",
                            color: "var(--text-muted)",
                          }}
                          className="skoroutoftext"
                        >
                          /{maxValue}
                        </div>
                      </div>
                      <div className="skoreset">
                        <div
                          className="skorstart"
                          style={{
                            fontSize: "var(--text-12)",
                            fontWeight: "500",
                            color: "var(--text-muted)",
                          }}
                        >
                          0
                        </div>
                        <div
                          style={{
                            fontSize: "var(--text-12)",
                            fontWeight: "500",
                            color: "var(--text-muted)",
                          }}
                          className="skorend"
                        >
                          {maxValue}
                        </div>
                      </div>
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
              </div>
            </div>

            {/* Score details */}
            <div className="col-7 col-md-6 skorSetDetailsWrapper">
              <div>
                <p className="style1">{_t("scoreStatus")}:</p>
                {/* 601–800 → ReliableText */}
                <h2 className="ReliableText">{_t("reliable")}</h2>
              </div>

              <div className="row mb-2 about-finical-skor">
                <div className="col-6">
                  <p className="style1">{_t("createdOn")}:</p>
                  <p className="style2">{createdOnDate}</p>
                </div>
                <div className="col-6">
                  <p className="style1">{_t("validTill")}:</p>
                  <p className="style2">{validTillDate}</p>
                </div>
              </div>

              <div className="about-finical-skor">
                <p className="style1">{_t("accountHolder")}:</p>
                <p className="style2 fw-bold">{accountHolder}</p>
              </div>

              <div className="bank-account-text-wrapper">
                {/* ie_verified=false, providerName≠"Uploaded from CSV" → bank account line */}
                <p className="style1">
                  {_t("bankAccountUsedForScoring")} {ibanTail}
                </p>
                {/* llShowOnly gif / animated-button block is landlord-only – omitted */}
              </div>

              {/* Mobile reconnect button (hidden on desktop via CSS) */}
              <button className="addGuarantorButton reconnectBankMobile reconnectBank me-0 d-flex align-items-center justify-content-center hideOnDesktop">
                {_t("reconnectBank")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsSkorStatic;
